import React from 'react';
import { Modal, Input, Select, Space, Typography } from 'antd';
import { DOCUMENT_TYPES } from '../constants/documentTypes';

const EditModal = ({
  isEditModalVisible,
  handleEditModalOk,
  setIsEditModalVisible,
  editFileName,
  setEditFileName,
  editCompany,
  setEditCompany,
  editType,
  setEditType,
  companies,
}) => {
  return (
    <Modal
      title="Edit Document Details"
      open={isEditModalVisible}
      onOk={handleEditModalOk}
      onCancel={() => setIsEditModalVisible(false)}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div>
          <Typography.Title level={5} style={{ marginBottom: '8px' }}>
            File Name
          </Typography.Title>
          <Input
            placeholder="Enter file name"
            value={editFileName}
            onChange={(e) => setEditFileName(e.target.value)}
            style={{ width: '100%' }}
          />
        </div>

        <div>
          <Typography.Title level={5} style={{ marginBottom: '8px' }}>
            Company Name
          </Typography.Title>
          <Select
            placeholder="Select Company"
            value={editCompany}
            onChange={setEditCompany}
            style={{ width: '100%' }}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            dropdownRender={(menu) => (
              <>
                {menu}
                <div style={{ padding: '8px', borderTop: '1px solid #e8e8e8' }}>
                  <Input
                    placeholder="Enter custom company name"
                    value={editCompany}
                    onChange={(e) => setEditCompany(e.target.value)}
                  />
                </div>
              </>
            )}
          >
            {companies.map(company => (
              <Select.Option key={company} value={company}>
                {company}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <Typography.Title level={5} style={{ marginBottom: '8px' }}>
            Document Type
          </Typography.Title>
          <Select
            placeholder="Select Document Type"
            value={editType}
            onChange={setEditType}
            style={{ width: '100%' }}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            dropdownRender={(menu) => (
              <>
                {menu}
                <div style={{ padding: '8px', borderTop: '1px solid #e8e8e8' }}>
                  <Input
                    placeholder="Enter custom document type"
                    value={editType}
                    onChange={(e) => setEditType(e.target.value)}
                  />
                </div>
              </>
            )}
          >
            {DOCUMENT_TYPES.map(type => (
              <Select.Option key={type} value={type}>
                {type}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Space>
    </Modal>
  );
};

export default EditModal;